// ═══════════════════════════════════════════════════════════════════════════
// PlayerBar — persistent audio/video player slot at the bottom of the app
// shell. Renders one of two states based on a feature flag:
//
//   v1   → PlayerBarPlaceholder (no playback, "Coming soon" copy)
//   v1.5 → PlayerBarActive (full controls — built next milestone)
//
// The flag lives in src/lib/featureFlags.js so flipping it on later is
// one line, not a sweep across files. AppShell mounts this once at the
// bottom of the layout; no per-page mounting needed.
//
// AppShell can pass `hidden` to suppress the bar on full-bleed surfaces
// (mobile Clips feed, future fullscreen views) without unmounting state.
// ═══════════════════════════════════════════════════════════════════════════

import React from 'react';
import PlayerBarPlaceholder from './PlayerBarPlaceholder';
import { isPlayerActive } from '../../lib/featureFlags';

export default function PlayerBar({ hidden = false, onLearnMoreV15 }) {
  if (hidden) return null;
  if (!isPlayerActive()) {
    return <PlayerBarPlaceholder onLearnMore={onLearnMoreV15} />;
  }
  // v1.5 active state slot — component shipped as a follow-up.
  return <PlayerBarPlaceholder onLearnMore={onLearnMoreV15} />;
}
